import React from "react";
import "./TopBar.css";

interface TopBarProps {
  title: React.ReactNode;
  // Buttons on the right, after the settings button's neighbours
  actions?: React.ReactNode;
  onOpenSidebar?: () => void;
  // The desktop sidebar is closed, so its open button shows here
  sidebarHidden?: boolean;
  onOpenSettings?: () => void;
}

// ModelLoop's sidebar icon: a panel with its divider and a chevron pointing out
const IconPanelOpen = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M9 3v18" />
    <path d="M13 9l3 3-3 3" />
  </svg>
);

const IconSettings = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

// The bar over the main column: menu (phones), a quiet centred title, glass buttons on the right
const TopBar: React.FC<TopBarProps> = ({
  title,
  actions,
  onOpenSidebar,
  sidebarHidden = false,
  onOpenSettings,
}) => (
  <header className="topbar">
    <div className="topbar-left">
      {onOpenSidebar && (
        <button
          type="button"
          className={`icon-btn stretchy topbar-menu-btn${sidebarHidden ? " is-sidebar-hidden" : ""}`}
          onClick={onOpenSidebar}
          aria-label="Open sidebar"
        >
          <IconPanelOpen />
        </button>
      )}
    </div>

    <span className="topbar-title">{title}</span>

    <div className="topbar-right">
      {actions}
      {onOpenSettings && (
        <button
          type="button"
          className="icon-btn stretchy"
          onClick={onOpenSettings}
          aria-label="Settings"
        >
          <IconSettings />
          <span className="tooltip tooltip--left">Settings</span>
        </button>
      )}
    </div>
  </header>
);

export default TopBar;
